// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Share_Wrapper__7Psc8","Toggle":"Share_Toggle__2HgCy","Container":"Share_Container__19p7z","Button":"Share_Button__KcFcy","Header":"Share_Header__138ul"};